/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "adp/services/edge_auth/proto/auth_metadata_service.proto" (package "adp.services.edge_auth.proto", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message adp.services.edge_auth.proto.CheckDomainAuthorizationRequest
 */
export interface CheckDomainAuthorizationRequest {
    /**
     * @generated from protobuf field: string domain = 1;
     */
    domain: string;
}
/**
 * @generated from protobuf message adp.services.edge_auth.proto.CheckDomainAuthorizationResponse
 */
export interface CheckDomainAuthorizationResponse {
    /**
     * @generated from protobuf field: adp.services.edge_auth.proto.DomainAuthorization authorization = 1;
     */
    authorization: DomainAuthorization;
}
/**
 * @generated from protobuf enum adp.services.edge_auth.proto.DomainAuthorization
 */
export enum DomainAuthorization {
    /**
     * @generated from protobuf enum value: DOMAIN_AUTHORIZATION_UNSPECIFIED = 0;
     */
    DOMAIN_AUTHORIZATION_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DOMAIN_AUTHORIZATION_AUTHORIZED = 1;
     */
    DOMAIN_AUTHORIZATION_AUTHORIZED = 1,
    /**
     * @generated from protobuf enum value: DOMAIN_AUTHORIZATION_UNAUTHORIZED = 2;
     */
    DOMAIN_AUTHORIZATION_UNAUTHORIZED = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class CheckDomainAuthorizationRequest$Type extends MessageType<CheckDomainAuthorizationRequest> {
    constructor() {
        super("adp.services.edge_auth.proto.CheckDomainAuthorizationRequest", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CheckDomainAuthorizationRequest>): CheckDomainAuthorizationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        if (value !== undefined)
            reflectionMergePartial<CheckDomainAuthorizationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckDomainAuthorizationRequest): CheckDomainAuthorizationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string domain */ 1:
                    message.domain = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckDomainAuthorizationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string domain = 1; */
        if (message.domain !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.domain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message adp.services.edge_auth.proto.CheckDomainAuthorizationRequest
 */
export const CheckDomainAuthorizationRequest = new CheckDomainAuthorizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckDomainAuthorizationResponse$Type extends MessageType<CheckDomainAuthorizationResponse> {
    constructor() {
        super("adp.services.edge_auth.proto.CheckDomainAuthorizationResponse", [
            { no: 1, name: "authorization", kind: "enum", T: () => ["adp.services.edge_auth.proto.DomainAuthorization", DomainAuthorization] }
        ]);
    }
    create(value?: PartialMessage<CheckDomainAuthorizationResponse>): CheckDomainAuthorizationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authorization = 0;
        if (value !== undefined)
            reflectionMergePartial<CheckDomainAuthorizationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckDomainAuthorizationResponse): CheckDomainAuthorizationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* adp.services.edge_auth.proto.DomainAuthorization authorization */ 1:
                    message.authorization = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckDomainAuthorizationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* adp.services.edge_auth.proto.DomainAuthorization authorization = 1; */
        if (message.authorization !== 0)
            writer.tag(1, WireType.Varint).int32(message.authorization);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message adp.services.edge_auth.proto.CheckDomainAuthorizationResponse
 */
export const CheckDomainAuthorizationResponse = new CheckDomainAuthorizationResponse$Type();
/**
 * @generated ServiceType for protobuf service adp.services.edge_auth.proto.AuthMetadata
 */
export const AuthMetadata = new ServiceType("adp.services.edge_auth.proto.AuthMetadata", [
    { name: "CheckDomainAuthorization", options: {}, I: CheckDomainAuthorizationRequest, O: CheckDomainAuthorizationResponse }
]);
